import React from 'react';
import styled from 'styled-components';
import { makeExternalUrl } from '../../../../lib/utils';
import { getMyZoneUtilityLinkProps } from './myZoneNavigationAnalytics';

const MyZoneEmptyStateDiv = styled.div`
  background-color: ${p => p.theme.c.bg.primary};
  box-shadow: 0 2px 8px 0 ${({ theme }) => theme.c.border['box-shadow']};
  border: solid 1px ${({ theme }) => theme.c.border.primary};
  text-align: left;
  margin-top: ${p => p.theme.unit(1)};
`;

const AnchorPaddingDiv = styled.div`
  padding: 0 ${p => p.theme.unit(3)};
  :hover {
    background-color: ${p => p.theme.c.bg.secondary};

    span {
      text-decoration: underline;
      color: ${({ theme }) => theme.c.text['interactive-hover']};
    }
  }
`;

const DropdownEntryAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  height: ${p => p.theme.unit(5)};
  width: 100%;
  text-decoration: none;
  cursor: pointer;
`;

const IconImg = styled.img`
  width: ${p => p.theme.unit(3)};
  padding-right: ${p => p.theme.unit(1)};
`;

const TitleSpan = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.interactive};
  min-width: ${p => p.theme.unit(18)};
  padding-top: 2px; // to center text
  text-decoration: none;
`;

const LeftSectionDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const LeftSectionPaddingDiv = styled.div`
  padding: ${p => p.theme.unit(3)} 0;
`;

const LeftSectionLink = (props) => {
  const {
    text,
    analyticsSlug,
    url,
    icon,
    locale,
  } = props;

  const resolvedIconUrl = makeExternalUrl(icon);
  const trackingProps = getMyZoneUtilityLinkProps({ analyticsSlug, url, locale });

  return (
    <AnchorPaddingDiv>
      <DropdownEntryAnchor
        {...trackingProps}>
        <IconImg src={resolvedIconUrl} />
        <TitleSpan>{text}</TitleSpan>
      </DropdownEntryAnchor>
    </AnchorPaddingDiv>
  );
};


const MyZoneDropdownEmptyState = (props) => {
  const {
    dropdownEntries,
    locale,
  } = props;

  const leftSection = dropdownEntries ? (
    <LeftSectionPaddingDiv>
      <LeftSectionDiv>
        {dropdownEntries.map((entry, index) => {
          const key = `entry-${index}`;
          return (
            <LeftSectionLink key={key} {...entry} locale={locale} />
          );
        })}
      </LeftSectionDiv>
    </LeftSectionPaddingDiv>
  ) : null;

  return (
    <MyZoneEmptyStateDiv>
      {leftSection}
    </MyZoneEmptyStateDiv>
  );
};

export default MyZoneDropdownEmptyState;
